export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "看料88 主要收录哪一类内容？",
    a: "看料88 是一个娱乐话题回顾与存档站，主要按时间线整理综艺、影视、创作者与网络热议相关的话题复盘、行业观察和年度盘点，帮助读者快速回顾某一段时间里讨论度较高的事件走向。",
  },
  {
    q: "往期内容怎么查找比较快？",
    a: "进入「往期存档」页面后，可以按分类切换，也可以直接在搜索框输入关键词。列表默认按发布时间从新到旧排列，每个条目都标注了分类、日期与预计阅读时长，方便你快速定位。",
  },
  {
    q: "站内内容会涉及未经证实的说法吗？",
    a: "不会。我们只基于公开信息进行现象层面的梳理与讨论，不发布未经证实的指控，也不对个人做主观定性。如果某条内容后续出现新的公开信息，我们会在盘点类文章中做补充说明。",
  },
  {
    q: "文章更新的频率大概是怎样的？",
    a: "热点类观察通常在话题出现后的一到两周内整理成文，盘点类内容按月度与季度固定更新。往期文章不会删除，只会在时间线上持续沉淀，方便回看。",
  },
  {
    q: "可以投稿或者提供线索吗？",
    a: "可以。你可以通过页脚的订阅与联系表单留下邮箱和内容方向，我们会定期查看。请尽量提供可公开查证的来源，方便我们判断是否适合整理成文。",
  },
  {
    q: "站内内容可以转载吗？",
    a: "用于个人学习与分享的引用，请注明来源与原文链接。如需整篇转载或用于商业用途，请先通过联系表单与我们沟通，获得授权后再使用。",
  },
  {
    q: "为什么同一事件会有多篇不同的文章？",
    a: "事件发酵与后续盘点属于不同的内容类型。前者关注当下的讨论走向，后者把事件放回更长的时间线里复盘。两者的侧重点不同，因此会分开成文。",
  },
  {
    q: "页面上的阅读时长是怎么估算的？",
    a: "阅读时长按照正文字数除以平均阅读速度估算，包含标题与小标题的浏览时间，仅作为参考，实际时长会因个人阅读习惯而不同。",
  },
];